import React from 'react'
import { Dropdown, ButtonGroup, Button, DropdownButton } from 'react-bootstrap'

export default function DetailsBtn({ status, handleClick }) {

  return ( <ButtonGroup>
      <Button onClick={() => handleClick('details')} className='details__btn'>Details</Button>

      <DropdownButton id='details__dropdown' title='' as={ButtonGroup}>
        {status === 'Active' &&
          <Dropdown.Item onClick={() => handleClick('revoke')}>Inactivate</Dropdown.Item>
        }
        {status === 'Pending' &&
          <Dropdown.Item onClick={() => handleClick('resend')}>Resend Email</Dropdown.Item>
        }
        {status === 'Inactive' &&
          <Dropdown.Item onClick={() => handleClick('activate')}>Re-activate</Dropdown.Item>
        }
      </DropdownButton>
    </ButtonGroup>
  )
}
